<div class="dialog">
  <h4 mat-dialog-title>{{ 'dialog_journey_title' | translate }}</h4>
  <form #form="ngForm" [appEnterToSave]="data">
    <mat-form-field>
      <mat-label>{{ 'common_field_distance' | translate }}</mat-label>
      <input matInput type="number" [(ngModel)]="data.distance" cdkFocusInitial name="displayName" min="0" required />
      <mat-error *ngIf="!data.distance" [innerHTML]="'dialog_journey_error_distance' | translate"></mat-error>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{ 'common_field_transport' | translate }}</mat-label>
      <mat-select name="transport" [value]="data?.transportId || data?.transports?.[0]?.resourceId" (selectionChange)="selectTransportChange($event.value)" required>
        <mat-option *ngFor="let t of data.transports" [value]="t.resourceId">{{ t?.displayName }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="data.familyCode == FamilyCodes.RoadTransportCode">
      <mat-label>{{ 'common_field_energy' | translate }}</mat-label>
      <mat-select name="energy" [(ngModel)]="data.energyId" (selectionChange)="selectEnergyChange($event.value)" required>
        <mat-option *ngFor="let e of data.energies" [value]="e.resourceId">{{ e?.displayName }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="data.familyCode != FamilyCodes.RoadTransportCode">
      <mat-label>{{ 'common_field_energy' | translate }}</mat-label>
      <input matInput type="string" [(ngModel)]="data.energieDescription" name="energyName" readonly disabled />
    </mat-form-field>

    <mat-checkbox *ngIf="data.familyCode == FamilyCodes.RoadTransportCode" [(ngModel)]="data.doubleCargo" name="doubleCargo">{{ 'common_double_freight' | translate }}</mat-checkbox>

    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="data" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
